import { FC, memo, SyntheticEvent } from 'react';
import classNames from 'classnames';

import Card from 'ui/Card';
import { Button, Input } from 'ui';
import { IUserCreateDetails } from 'entities/view/userCreate';
import FileUploader from 'ui/FileUploader';

type PropTypes = {
  detail: IUserCreateDetails;
  detailIndex: number;
  onAddNewZone: (detailIndex: number) => void;
  onAddObjectSensor: (detailIndex: number) => void;
  onRemoveObject?: (detailIndex: number) => void;
  onFileRemove?: (detailIndex: number) => void;
  onFileUpload: (detailIndex: number) => (file: File) => void;
  onNameChange: (detailIndex: number, value: string) => void;
  error?: string;
  fileError?: string;
};

const ObjectDetails: FC<PropTypes> = ({
  detail,
  detailIndex,
  onAddNewZone,
  onAddObjectSensor,
  onFileUpload,
  onFileRemove,
  onRemoveObject,
  onNameChange,
  error,
  fileError,
}) => {
  const handleFileRemove = (event?: SyntheticEvent) => {
    event?.preventDefault();
    event?.stopPropagation();

    if (onFileRemove) onFileRemove(detailIndex);
  };

  return (
    <Card
      title="Object details"
      className={classNames('step-two__object', {
        'has-child': detail?.zones?.length || detail?.sensors?.length,
      })}
      onRemove={
        !!onRemoveObject ? () => onRemoveObject(detailIndex) : undefined
      }
    >
      <div className="step-two__object-inputs">
        <Input
          value={detail?.name}
          label={'Object name'}
          placeholder="Object name"
          maxLength={100}
          name={`name-${detailIndex}`}
          wrapperClassName="step-two__object-input"
          onChange={(e) => onNameChange(detailIndex, e.target.value)}
          error={error}
          variant="white"
        />

        <FileUploader
          file={detail?.file}
          originalFilename={detail?.originalFilename}
          onRemove={handleFileRemove}
          onUpload={onFileUpload(detailIndex)}
          name={`uploader-${detailIndex}`}
          error={fileError}
        />
      </div>

      <div className="step-two__object-actions">
        <Button
          type={'button'}
          variant="secondary"
          onClick={() => onAddNewZone(detailIndex)}
        >
          Add new zone
        </Button>

        <Button
          type={'button'}
          variant="secondary"
          onClick={() => onAddObjectSensor(detailIndex)}
        >
          Add new object sensor
        </Button>
      </div>
    </Card>
  );
};

export default memo(ObjectDetails);
